<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">

        <div class="card">
            <FlashMessage :position="'right top'"></FlashMessage>

            <div class="card-header">
                <h4 class="title">Edit Lead</h4>
            </div>
            <div class="card-body">
                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Promotion<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.leaddata.promotionid.$model">
                                <option disabled value>Select promotion</option>
                                <option v-for="(list, index) in promotion" :value="list.promotionid" :key="index">
                                    {{ list.promotion }}
                                </option>
                            </select>
                            <div class="error" v-if="submitted && !$v.leaddata.promotionid.required">Please select promotion</div>
                        </div>

                        <div class="col-md-4">
                            <label>Referral<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.leaddata.referralid.$model">
                                <option disabled value>Select referral</option>
                                <option v-for="(list, index) in referral" :value="list.referralid" :key="index">
                                    {{ list.referral }}
                                </option>
                            </select>
                            <div class="error" v-if="submitted && !$v.leaddata.referralid.required">Please select referralid</div>
                        </div>

                        <div class="col-md-4">
                            <label>Follow Date<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.leaddata.followdate.$model" type="date" label="date" />
                            <div class="error" v-if="submitted && !$v.leaddata.followdate.required">Please select follow date</div>
                        </div>

                    </div><br>

                    <div class="row">
                        <div class="col-md-4">
                            <label>Name<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.leaddata.name.$model" type="text" label="name" placeholder="Enter name" />
                            <div class="error" v-if="submitted && !$v.leaddata.name.required">Please enter name</div>
                        </div>

                        <div class="col-md-4">
                            <label>Number<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.leaddata.number.$model" type="text" label="number" placeholder="Enter number" @keypress="onlyNumber" maxlength="10" />
                            <div class="error" v-if="submitted && !$v.leaddata.number.required">Please enter number</div>
                            <div v-if="submitted && !$v.leaddata.number.minLength" class="error">
                                Please enter valid mobile number
                            </div>
                            <div v-if="submitted && !$v.leaddata.number.maxLength" class="error">
                                Please enter valid mobile number
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label>Email<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.leaddata.email.$model" type="text" label="email" placeholder="Enter email" />
                            <div class="error" v-if="submitted && !$v.leaddata.email.required">Please enter email</div>
                            <div class="error" v-if="submitted && !$v.leaddata.email.email">Please enter valid email</div>

                        </div>
                    </div><br>

                    <div class="row">
                        <div class="col-md-4">
                            <label>Address Line1</label>
                            <input class="form-control" v-model.trim="leaddata.addline1" type="text" label="addline1" placeholder="Enter address line 1" />
                            <!-- <div class="error" v-if="submitted && !$v.leaddata.addline1.required">Please enter address line 1</div> -->
                        </div>

                        <div class="col-md-4">
                            <label>Address Line2</label>
                            <input class="form-control" v-model.trim="leaddata.addline2" type="text" label="addline2" placeholder="Enter address line 2" />
                            <!-- <div class="error" v-if="submitted && !$v.leaddata.addline2.required">Please enter address line 2</div> -->

                        </div>

                        <div class="col-md-4">
                            <label for="country">Country</label>
                            <select class="form-control first_null" v-model="leaddata.country" @change="onChangeCountry" id="country">
                                <option value="" selected disabled>Select country</option>
                                <option v-for="(country, index) in listCountry" :value="country.country_name" :key="index">
                                    {{ country.country_name }}
                                </option>
                            </select>
                            <!-- <div v-if="submitted && !$v.leaddata.country.required" class="invalid-feedback">Selct country</div> -->

                        </div>
                    </div><br>

                    <div class="row">
                        <div class="col-md-4">
                            <label for="state">State</label>
                            <select class="form-control first_null" v-model="leaddata.state" :disabled="listState.length == 0" @change="onChangeState" id="state">
                                <option value="" selected disabled>Select state</option>
                                <option v-for="(state, index) in listState" :key="index" :value="state.state_name">
                                    {{ state.state_name }}
                                </option>
                            </select>
                            <!-- <div v-if="submitted && !$v.leaddata.state.required" class="invalid-feedback">Select state</div> -->

                        </div>

                        <div class="col-md-4">
                            <label for="city">City</label>
                            <select class="form-control first_null" v-model="leaddata.city" :disabled="listCities.length == 0" id="city">
                                <option value="" selected disabled>Select city</option>
                                <option v-for="(city, index) in listCities" :key="index" :value="city.city_name">
                                    {{ city.city_name }}
                                </option>
                            </select>
                            <!-- <div v-if="submitted && !$v.leaddata.city.required" class="invalid-feedback">Select city</div> -->
                        </div>

                        <div class="col-md-4">
                            <label for="pincode">Pincode</label>
                            <input type="text" class="form-control" v-model="leaddata.pincode" id="pincode" placeholder="Enter pincode" @keypress="onlyNumber" maxlength="6">
                            <!-- <div v-if="submitted && !$v.leaddata.pincode.required" class="invalid-feedback">Pincode is required</div> -->
                        </div>

                    </div><br>

                    <div class="row">
                        <div class="col-md-4">
                            <label for="status">Status<em style="color:red">*</em></label>
                            <select class="form-control first_null" v-model="$v.leaddata.status.$model" id="status">
                                <option selected disabled value>Select status</option>
                                <option v-for="(item, index) in allstatus" :key="index" :value="item.leadstatusid">
                                    {{ item.leadstatusname }}
                                </option>
                            </select>
                            <div v-if="submitted && !$v.leaddata.status.required" class="error">Select status</div>

                        </div>

                        <div class="col-md-4">
                            <label for="assignuser">Assign User</label>
                            <select class="form-control first_null" v-model="leaddata.assignuser" id="assignuser">
                                <option value="" selected disabled>Select assign user</option>
                                <option v-for="(item, index) in allassignuser" :key="index" :value="item.id">
                                    {{ item.name }}
                                </option>
                            </select>
                            <!-- <div v-if="submitted && !$v.leaddata.assignuser.required" class="invalid-feedback">Select assign user</div> -->
                        </div>


                    </div><br>

                    <div class="row">
                       
                        <div class="col-md-12">
                            <label for="enquiry">Enquiry</label>
                            <textarea class="form-control" placeholder="Enter enquiry" v-model="leaddata.enquiry"></textarea>
                            <!-- <div v-if="submitted && !$v.leaddata.enquiry.required" class="error">Select status</div> -->
                        </div>

                    </div>

                    <div class="text">
                        <button type="submit" class="btn btn-secondary dashboard">Update</button>&nbsp;
                        <router-link to="/admin/dashboard/lead"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>

                    </div>

                </form>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

    
<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import {
    required,
    minLength,
    maxLength,
    between,
    email,
} from "vuelidate/lib/validators";
export default {
    name: 'addLead',
    components: {
        TopNavbar,
        ContentFooter,
        ValidationError,
    },

    data() {
        return {
            submitted: false,
            promotion: [],
            referral: [],
            listCountry: [],
            listState: [],
            listCities: [],
            allassignuser: [],
            allstatus: [],
            authToken: "",
            leaddata: {
                promotionid: '',
                referralid: '',
                followdate: '',
                name: '',
                number: '',
                email: '',
                addline1: '',
                addline2: '',
                country: '',
                state: '',
                city: '',
                pincode: '',
                status: '',
                assignuser: '',
                enquiry: '',
            }

        }
    },

    validations: {
        leaddata: {
            promotionid: {
                required
            },
            referralid: {
                required
            },
            followdate: {
                required,
            },
            name: {
                required,
            },
            number: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(10),
            },
            email: {
                required,
                email,
            },
            // addline1: {
            //     required,
            // },
            // addline2: {
            //     required,
            // },
            // country: {
            //     required
            // },
            // state: {
            //     required
            // },
            // city: {
            //     required
            // },
            // pincode: {
            //     required
            // },
            status: {
                required
            },
            // assignuser: {
            //     required
            // },
        }
    },

    methods: {
        onlyNumber($event) {
            //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },

        submit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/lead/update/` + this.$route.params.id, this.leaddata)
                    .then(({
                        data
                    }) => {
                        this.flashMessage.success({
                            message: 'Lead Update Successfully',
                        });

                        this.$router.push('/admin/dashboard/lead');
                    })
                // .catch((error) => {
                //     console.log(error);
                // });

            }
        },

        async loadCountry() {
            await this.axios.get("https://www.universal-tutorial.com/api/countries", {
                    headers: {
                        Authorization: `Bearer ${this.authToken}`,
                        Accept: "application/json",
                    },
                })
                .then((res) => {
                    this.listCountry = res.data;
                    this.onChangeCountry();
                });
        },
        async onChangeCountry() {
            await this.axios
                .get(
                    `https://www.universal-tutorial.com/api/states/${this.leaddata.country}`, {
                        headers: {
                            Authorization: `Bearer ${this.authToken}`,
                            Accept: "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.listState = res.data;
                    this.onChangeState();
                });
        },
        async onChangeState() {
            await this.axios
                .get(
                    `https://www.universal-tutorial.com/api/cities/${this.leaddata.state}`, {
                        headers: {
                            Authorization: `Bearer ${this.authToken}`,
                            Accept: "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.listCities = res.data;
                });
        },

        onlyNumber($event) {
            //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },
    },

    async mounted() {

        const leaddata = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/lead/edit/` + this.$route.params.id);
        this.leaddata = leaddata.data.data;

        await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getactivepromotion`).then((res) => {
            this.promotion = res.data;
        });

        await this.axios.get("https://www.universal-tutorial.com/api/getaccesstoken", {
                headers: {
                    Accept: "application/json",
                    "api-token": "jAJuES2nNREYu0qOJ9Sy6bydr_LPxmjv0jUAR-oEuXozRP_CjqPqRgp1mCPaNh8VPZo",
                    "user-email": "itjebasuthan@gmail.com",
                },
            })
            .then((res) => {
                this.authToken = res.data.auth_token;
                this.loadCountry();
            });

        await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/leadstatus`).then((res) => {
            this.allstatus = res.data;
        });

        await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/assignuser`).then((res) => {
            this.allassignuser = res.data;
        });

    },

    watch: {
        'leaddata.promotionid': function (value) {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/referral/` + this.leaddata.promotionid).then((referral) => {
                this.referral = referral.data;
            });
        }
    },
};
</script>

    
<style lang="scss">
        </style>
